<div class="md-category-all-explore">
    {{ "Explore further deals:" | translate }}
</div>

<div class="md-category-listings">
    <!-- Iterate through the product listings -->
    <div
        class="md-cat-list-card-wrapper"
        *ngFor="let data of categoryData; let i = index"
    >
        <md-product-card
            [dealEntry]="data"
            (dealSelected)="redirectToProdDetail(data.id, data.productPath)"
        ></md-product-card>

        <!-- Loading more items indicator -->
        <div
            [hidden]="!loadingMoreDeals"
            *ngIf="
                categoryData.length < totalRecords &&
                categoryData.length >= 20 &&
                i + 1 == categoryData.length
            "
        >
            <div class="view_more custom-user-review-div-23">
                {{ "Loading more" | translate }}
            </div>
        </div>
    </div>
</div>
